/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * Typ položky.
 * @export
 * @enum {string}
 */

export const LegendItemType = {
    POINT: 'point',
    LINE: 'line',
    POLYGON: 'polygon',
    IMAGE: 'image'
} as const;

export type LegendItemType = typeof LegendItemType[keyof typeof LegendItemType];



